import {
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Image,
  Stack,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import ReturnDrawerMobile from './ReturnDrawerMobile'
import {
  validateCheckboxBrand,
  validateCheckboxVolume,
  validateCheckboxMaterial,
  validateCheckboxReturnability
} from '../utils/functionsValidateProduct'
import { CloseIcon } from '@chakra-ui/icons'
const quilmesImages = require.context('../assets/images', true)

const FilterCheckboxMobile = ({ sizeS, productsApi, Checked, setChecked }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleChecked = (e) => {
    const { value } = e.target
    const newChecked = [...Checked]
    const index = newChecked.indexOf(value)

    if (index === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(index, 1)
    }

    setChecked(newChecked)
  }

  return (
    <Stack
      alignItems={'center'}
      display={'flex'}
      flexDirection={'row'}
      gap={2}
      justifyContent={'center'}
    >
      <Button
        bg={'#FFF'}
        border={'1px solid #DB580B'}
        color={'#DB580B'}
        leftIcon={
          <Image
            height={'20px'}
            src={quilmesImages('./filter.svg')}
            width={'20px'}
            onClick={onOpen}
          />
        }
        rightIcon={
          <Box>
            {Checked.length > 0 && (
            <Text
              bg={'#DB580B'}
              borderRadius={'50%'}
              color={'#FFF'}
              fontSize={'14px'}
              height={'20px'}
              paddingTop={'.1rem'}
              width={'20px'}
            >
              {Checked.length}
            </Text>
            )}{' '}
          </Box>
        }
        onClick={onOpen}
      >
        Filtrar
      </Button>
      <Stack>
        <Drawer
          isOpen={isOpen}
          maxWidth={'100%'}
          size={sizeS}
          onClose={onClose}
        >
          <DrawerOverlay />
          <DrawerContent>
            <ReturnDrawerMobile onClose={onClose} />
            <DrawerBody paddingTop={2}>
              <Text fontSize={'24px'}>Filtros</Text>
              <Box
                display={'flex'}
                flexDirection={'row'}
                flexFlow={'wrap'}
                gap={2}
                marginBottom={2}
                paddingTop={2}
              >
                {Checked.length > 0 &&
                  Checked.map((product, index) => (
                    <Button
                      key={index}
                      _active={{ bg: '#F4E7DF' }}
                      _hover={{ bg: '#F4E7DF' }}
                      bg={'#F4E7DF'}
                      border={'1px solid #DB580B'}
                      color={'#DB580B'}
                      fontSize={'14px'}
                      fontWeight={600}
                      marginBottom={2}
                      rightIcon={<CloseIcon h={3} w={3} />}
                      w={'max-content'}
                      onClick={() => {
                        const newChecked = Checked.filter(
                          (item) => item !== product
                        )

                        setChecked(newChecked)
                      }}
                    >
                      {product}
                    </Button>
                  ))}
              </Box>
              <Text color={'#0A0808'} fontSize={'16px'} marginBottom={'1rem'}>
                Marca
              </Text>
              <Stack direction='column' spacing={5}>
                {productsApi
                  .filter((product, index, self) => {
                    return (
                      index ===
                      self.findIndex(
                        (t) => t.brand.description === product.brand.description
                      )
                    )
                  })
                  .sort((a, b) =>
                    a.brand.description.toLowerCase() <
                    b.brand.description.toLowerCase()
                      ? -1
                      : 1
                  )
                  .map((item) =>
                    <Checkbox
                      {...Checked.includes(item.brand.description) ? { isChecked: true } : { isChecked: false }}
                      {...validateCheckboxBrand(Checked) &&
                    !Checked.includes(item.brand.description)
                        ? { isDisabled: true }
                        : { isDisabled: false }}
                      key={item.brand.brandId}
                      name='volume'
                      value={item.brand.description}
                      onChange={handleChecked}
                    >{item.brand.description}</Checkbox>
                  )}
              </Stack>

              <Divider borderColor={'#E1E1E1'} marginTop={4} />

              <Text
                color={'#0A0808'}
                fontSize={'16px'}
                marginBottom={'1rem'}
                marginTop={'1rem'}
              >
                Litros
              </Text>

              <Stack direction='column' spacing={5}>
                {productsApi
                  .filter((product, index, self) => {
                    return (
                      index ===
                      self.findIndex(
                        (t) =>
                          t.volume.description === product.volume.description
                      )
                    )
                  })
                  .sort((a, b) =>
                    a.volume.description.toLowerCase() <
                    b.volume.description.toLowerCase()
                      ? -1
                      : 1
                  )
                  .map((item) =>
                    <Checkbox
                      {...Checked.includes(item.volume.description) ? { isChecked: true } : { isChecked: false }}
                      // si selecciono 1,5L deshabilita los demas
                      {...validateCheckboxVolume(Checked) &&
                  !Checked.includes(item.volume.description)
                        ? { isDisabled: true }
                        : { isDisabled: false }}
                      key={item.volume.volumeId}
                      name='volume'
                      value={item.volume.description}
                      onChange={handleChecked}
                    >{item.volume.description}</Checkbox>
                  )}
              </Stack>

              <Divider borderColor={'#E1E1E1'} marginTop={4} />

              <Text
                color={'#0A0808'}
                fontSize={'16px'}
                marginBottom={'1rem'}
                marginTop={'1rem'}
              >
                Material
              </Text>
              <Stack direction='column' spacing={5}>
                {productsApi
                  .filter((product, index, self) => {
                    return (
                      index ===
                      self.findIndex(
                        (t) =>
                          t.material.description ===
                          product.material.description
                      )
                    )
                  })
                  .sort((a, b) =>
                    a.material.description.toLowerCase() <
                    b.material.description.toLowerCase()
                      ? -1
                      : 1
                  )
                  .map((item) =>
                    <Checkbox
                      {...Checked.includes(item.material.description) ? { isChecked: true } : { isChecked: false }}
                      {...validateCheckboxMaterial(Checked) &&
                    !Checked.includes(item.material.description)
                        ? { isDisabled: true }
                        : { isDisabled: false }}
                      key={item.material.materialId}
                      name='material'
                      value={item.material.description}
                      onChange={handleChecked}
                    > {item.material.description}</Checkbox>
                  )}
              </Stack>

              <Divider borderColor={'#E1E1E1'} marginTop={4} />

              <Text
                color={'#0A0808'}
                fontSize={'16px'}
                marginBottom={'1rem'}
                marginTop={'1rem'}
              >
                Envase
              </Text>
              <Stack direction='column' height={'30vh'} spacing={5}>
                {productsApi
                  .filter((product, index, self) => {
                    return (
                      index ===
                      self.findIndex(
                        (t) =>
                          t.returnability.description ===
                          product.returnability.description
                      )
                    )
                  })
                  .sort((a, b) =>
                    a.returnability.description.toLowerCase() <
                    b.returnability.description.toLowerCase()
                      ? -1
                      : 1
                  )
                  .map((item) =>
                    <Checkbox
                      {...Checked.includes(item.returnability.description) ? { isChecked: true } : { isChecked: false }}
                      {...validateCheckboxReturnability(Checked) &&
                    !Checked.includes(item.returnability.description)
                        ? { isDisabled: true }
                        : { isDisabled: false }}
                      key={item.returnability.returnabilityId}
                      name='returnability'
                      value={item.returnability.description}
                      onChange={handleChecked}
                    > {item.returnability.description}</Checkbox>
                  )}
              </Stack>

              <Stack
                alignItems={'center'}
                bg={'#F7F7F7'}
                bottom={0}
                justifyContent={'center'}
                left={0}
                marginTop={'-.5rem !important'}
                paddingBottom={'2rem'}
                paddingTop='2rem'
                position={'fixed'}
                w={'100%'}
              >
                <Button
                  isDisabled={!Checked.length}
                  margin={0}
                  marginBottom={'1rem'}
                  type='submit'
                  variant='btn-quilmes'
                  w={'90%'}
                  onClick={onClose}
                >
                  Seleccionar
                </Button>
              </Stack>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Stack>
    </Stack>
  )
}

export default FilterCheckboxMobile
